var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"confirmGuide",attrs:{"visible":_vm.visible,"show-close":false}},[_c('div',{staticClass:"confirmGuideMain"},[_c('div',{staticClass:"m-t-25 p-t-130 p-l-200"},[_c('el-button',{attrs:{"type":"primary","size":"medium","round":""},on:{"click":_vm.closeGuide}},[_vm._v("\n        我知道了\n      ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }